/**
 * Creates a local timezone Date from one in UTC. Intended to be used with
 * timestamps that don't contain timezone information and are expected to be set
 * in UTC.
 */
export class UTCDate extends Date {
    constructor(dateInit) {
        const date = dateInit ? new Date(dateInit) : new Date();
        const offset = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
        super(offset);
    }
    getTimezoneOffset() {
        return 0;
    }
}
//# sourceMappingURL=UTCDate.js.map